import { handleDownloadDPSSHJParentsAgreement } from "hooks/downloads";
import {
  handleDownloadDPSRAKRoutes,
  handleDownloadDPSSHJSNRRoutes,
  handleDownloadDPSSHJPRIRoutes,
  handleDownloadDPSSHJSNRDD,
  handleDownloadDPSSHJPRIDD,
  handleDownloadTraAgrFormRAK,
  handleDownloadTraAgrForm,
  handleDownloadASBT,
  handleDownloadNBT,
  handleDownloadSTAFFASBT,
  handleDownloadSTAFFNBT,
  handleDownloadDPSRAKDRIVERDETAILS,
  handleDownloadDPSSHJSNRRoutesMobile,
} from "hooks/downloads";

export const navConfigDrawer = [
  {
    title: "About Us",
    path: "/about-us",
  },

  {
    title: "Our Services",
    path: "/services/service-summary",
  },

  {
    title: "Bus Route DPS Sharjah Primary",
    // action: handleDownloadDPSSHJPRIRoutes,
    action: handleDownloadDPSSHJPRIRoutes,
  },
  {
    title: "Bus Route DPS Sharjah Senior",
    action: handleDownloadDPSSHJSNRRoutes,
  },
  {
    title: "Bus Route DPS RAK",
    action: handleDownloadDPSRAKRoutes,
  },

  {
    title: "Driver Details DPS Sharjah Primary",
    action: handleDownloadDPSSHJPRIDD,
  },
  {
    title: "Driver Details DPS Sharjah Senior",
    action: handleDownloadDPSSHJSNRDD,
  },
  {
    title: "Driver Details DPS RAK",
    action: handleDownloadDPSRAKDRIVERDETAILS,
  },

  {
    title: "Fee Details",
    path: "/fees/details",
  },

  {
    title: "NBT Parents Agreement Form DPS Sharjah Primary",
    action: handleDownloadDPSSHJParentsAgreement,
  },
  {
    title: "NBT Parents Agreement Form DPS Sharjah Senior",
    action: handleDownloadDPSSHJParentsAgreement,
  },
  {
    title: "NBT Parents Agreement Form DPS RAK",
    action: handleDownloadDPSSHJParentsAgreement,
  },
  {
    title: "Payment Details",
    path: "/fees/payment-modes",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navConfig = [
  {
    title: "About Us",
    path: "/about-us",
  },
  {
    title: "Services",
    path: "/services",
    children: [
      {
        title: "Our Services",
        path: "/services/service-summary",
      },
      {
        title: "Bus Route Details",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadDPSSHJPRIRoutes,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRRoutes,
          },
          {
            title: "DPS RAK",
            action: handleDownloadDPSRAKRoutes,
          },
        ],
      },
      {
        title: "Driver Details Download",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadDPSSHJPRIDD,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRDD,
          },
          {
            title: "DPS RAK",
            action: handleDownloadDPSRAKDRIVERDETAILS,
          },
        ],
      },
    ],
  },
  {
    title: "Fees",
    path: "/fees",
    children: [
      {
        title: "Fee Details",
        path: "/fees/details",
      },
      {
        title: "NBT Parents Agreement Form",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS RAK",
            action: handleDownloadTraAgrFormRAK,
          },
        ],
      },
      {
        title: "Payment Details",
        path: "/fees/payment-modes",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navconfigNew = (navigate) => {
  return [
    {
      label: "Home",
      path: "/",
    },
    {
      label: "Our Services",
      path: "/services",
      items: [
        {
          label: "School transportation",
          path: "/transport",
          callback: () => navigate("/services/transport"),
        },
        {
          label: "Vehicle Maintenance",
          path: "/maintance",
          callback: () => navigate("/services/maintenance"),
        },
      ],
    },
    {
      label: "Bus Routes",
      path: "",
      items: [
        {
          label: "DPS Sharjah",
          items: [
            { label: "Primary Section", callback: handleDownloadDPSSHJPRIRoutes },
            { label: "Senior Section", callback: handleDownloadDPSSHJSNRRoutes },
          ],
        },
        {
          label: "DPS RAK",
          callback: handleDownloadDPSRAKRoutes,
        },
        {
          label: "Driver Details",
          items: [
            {
              label: "DPS Sharjah",
              items: [
                { label: "Primary Section", callback: handleDownloadDPSSHJPRIDD },
                { label: "Senior Section", callback: handleDownloadDPSSHJSNRDD },
              ],
            },
            {
              label: "DPS RAK",
              callback: handleDownloadDPSRAKDRIVERDETAILS,
            },
          ],
        },
        {
          label: "FAQs",
          path: "/faq/logistics",
          callback: () => navigate("/faq/logistics"),
        },
      ],
    },
    {
      label: "Forms",
      path: "",
      items: [
        {
          label: "Transport form - NBT",
          callback: handleDownloadNBT,
        },
        {
          label: "Transport form for staff - NBT",
          callback: handleDownloadSTAFFNBT,
        },
      ],
    },
    {
      label: "Fees",
      path: "/fees",
      items: [
        {
          label: "DPS Sharjah",
          path: "/fees/dps-sharjah",
          callback: () => navigate("/fees/dps-sharjah"),
        },
        {
          label: "DPS RAK",
          path: "/fees/dps-rak",
          callback: () => navigate("/fees/dps-rak"),
        },
        {
          label: "NBT Parents Agreement Form",
          callback: handleDownloadDPSSHJParentsAgreement,
        },
        {
          label: "FAQs",
          path: "/faq/fees",
          callback: () => navigate("/faq/fees"),
        },
      ],
    },
    {
      label: "Careers",
      path: "/careers/list",
      callback: () => navigate("/careers/list"),
    },
  ];
};
